import CodeEditor from "../components/CodeEditor/CodeEditor";
import Image from "../components/Image/Image";
import Charts from "../components/Charts/Charts";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import formatNumber from "./formatNumber";

const parseHTML = (htmlString, data) => {
  const options = {
    replace: ({ name, attribs, children }) => {
      if (name === "img") {
        return (
          <Image
            width="100%"
            source={data?.images[attribs.src] || attribs.src}
            alternativetext={attribs.alt}
            caption={parseHTML(attribs.alt, data)}
          />
        );
      }

      if (name === "a") {
        const value = children
          ?.map((el) => {
            if (el?.type === "text") return el?.data;
            if (el?.type === "tag" && el?.name === "br") return "\n";
          })
          ?.join("");

        if (attribs.type === "internalLink") {
          return (
            <b>
              <Link
                to={data?.links[attribs.href] || attribs.href}
                className={
                  attribs.type === "text" ? "text-muted" : "visualizeLink"
                }
              />
            </b>
          );
        }

        return (
          <a
            href={data?.links[attribs.href] || attribs.href}
            target={attribs.target}
            className={attribs.type === "text" ? "text-muted" : "visualizeLink"}
          >
            <b>{value}</b>
          </a>
        );
      }

      if (name === "code") {
        const value = children
          ?.map((el) => {
            if (el?.type === "text") return el?.data;
            if (el?.type === "tag" && el?.name === "br") return "\n";
          })
          ?.join("");

        return (
          <CodeEditor height="200px" language={attribs.lang} value={value} />
        );
      }

      if (name === "table" && attribs.classname === "sankey") {
        //* create tooltip
        const createTooltip = (name, value, type) => {
          return `${name}: ${type === "costs" ? "-" : ""}${formatNumber(
            value
          )} ${attribs.id}`;
        };

        const caption = children
          ?.find((el) => el.name === "caption")
          ?.children?.[0]?.data?.trim();

        const rows = children
          ?.find((el) => el.name === "tbody")
          ?.children?.filter((el) => el.name === "tr");

        const sankeyData = [
          [
            "From",
            "To",
            "Summe",
            { type: "string", role: "tooltip" },
            { type: "string", role: "style" },
          ],
        ];

        rows?.forEach((row) => {
          const type = row.attribs?.["data-type"]; // "income" | "cost"
          const cells = row.children?.filter((el) => el.name === "td");
          if (cells?.length >= 4) {
            const name = cells[0].children?.[0]?.data?.trim();
            const from = cells[1].children?.[0]?.data?.trim();
            const to = cells[2].children?.[0]?.data?.trim();
            const value = parseFloat(cells[3].children?.[0]?.data?.trim());

            const style =
              type === "income" ? "color: #05bf02" : "color: #FF2400";

            if (from && to && !isNaN(value)) {
              const tooltip = createTooltip(name, value, type);
              sankeyData.push([from, to, value, tooltip, style]);
            }
          }
        });

        return (
          <>
            <Charts.Sankey data={sankeyData} raw />
            <p className="image-caption text-muted">{caption}</p>
          </>
        );
      }
    },
  };

  return parse(htmlString, options);
};

export default parseHTML;
